var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.13 11.3401C14.52 9.70008 13.09 8.27003 11.45 8.66003C10.68 8.85003 10.05 9.48005 9.85998 10.2501C9.46998 11.8901 10.9 13.32 12.54 12.93C13.32 12.74 13.95 12.1101 14.13 11.3401Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0099 17.19C19.7199 15.59 20.7899 13.32 20.7899 10.79C20.7899 5.92998 16.85 2 12 2C7.14995 2 3.20996 5.93998 3.20996 10.79C3.20996 13.33 4.28996 15.62 6.01996 17.22",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 14.55C7.08002 13.57 6.51001 12.25 6.51001 10.79C6.51001 7.76004 8.97002 5.30005 12 5.30005C15.03 5.30005 17.49 7.76004 17.49 10.79C17.49 12.25 16.92 13.56 16 14.55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 16.66L8.85998 18.4501C7.71998 19.8801 8.72997 21.99 10.56 21.99H13.43C15.26 21.99 16.28 19.8701 15.13 18.4501L13.69 16.66C12.83 15.57 11.17 15.57 10.3 16.66Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdrop);
export default __webpack_public_path__ + "static/media/airdrop.f6fc18e80429b2582520cd909a8f3fc6.svg";
export { ForwardRef as ReactComponent };